module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    staticClass: "mdl-dialog"
  }, [_c('h4', {
    staticClass: "mdl-dialog__title"
  }, [_vm._t("title")], 2), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_vm._t("content")], 2), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [_vm._t("buttons", [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.$el.close(true)
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$el.close(false)
      }
    }
  }, [_vm._v("Avbryt")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4459c0f5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dialog/Dialog.vue
// module id = 513
// module chunks = 1